import { render, staticRenderFns } from "./LightCommand.vue?vue&type=template&id=3d05966d&scoped=true"
import script from "./LightCommand.vue?vue&type=script&lang=js"
export * from "./LightCommand.vue?vue&type=script&lang=js"
import style0 from "./LightCommand.vue?vue&type=style&index=0&id=3d05966d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05966d",
  null
  
)

export default component.exports